import C from '../../../constants';

export default function clearFlashAlert(key) {
  return {
    type: C.CLEAR_FLASH_ALERT,
    key,
  };
}
